const modStateKey = (inventoryID, attachmentKey, mod, index) => `${inventoryID}-${attachmentKey}-${mod.Key || "MOD" + index}`

export default modStateKey
